module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"I Miei Appuntamenti","pageMetaDescription":"-","NoBookings":"Nessun appuntamento trovato"}}')
  delete Component.options._Ctor
}
